<template>
  <div class="tools02-bussiness-accounts-account-list">
    <el-row>
      <el-col>
        <router-link to="bussiness-account-detail/0">
          <el-button type="primary" class="new-add">新規追加</el-button>
        </router-link>
      </el-col>
    </el-row>
    <el-row v-if="userData.bonusPointData[tool.codeCamel].auth === false">
      <el-col>
        <UiBonusAlert :toolCode="tool.codeCamel" :bonusCode="'auth'" boxStyle="fat" />
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <div class="cover">
          <table class="typeA stripe">
            <thead>
              <tr>
                <th>Yahoo!JAPAN ビジネスID</th>
                <th style="width: 100px"></th>
                <th style="width: 50px"></th>
                <th style="width: 50px"></th>
              </tr>
            </thead>
            <tbody v-if="bussinessAccountList.length > 0">
              <tr v-for="bussinessAccountData in bussinessAccountList" :key="bussinessAccountData.bussinessAccountId">
                <td>
                  {{ bussinessAccountData.bussinessId }}
                </td>
                <td>
                  <div style="text-align: center">
                    <el-button v-if="bussinessAccountData.apiAuth === true"
                      @click="authorize(bussinessAccountData.bussinessAccountId)" type="success">
                      連携済み
                    </el-button>
                    <el-button v-else
                      @click="authorize(bussinessAccountData.bussinessAccountId)" type="primary">
                      認証
                    </el-button>
                  </div>
                </td>
                <td>
                  <router-link :to="`bussiness-account-detail/${bussinessAccountData.bussinessAccountId}`">
                    <el-button type="">編集</el-button>
                  </router-link>
                </td>
                <td>
                  <el-button @click="
                    deleteBussinessAccount(
                      bussinessAccountData.bussinessAccountId,
                      bussinessAccountData.bussinessId
                    )
                    " type="danger">削除</el-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UiBonusAlert from "@/components/Ui/BonusAlert.vue";

export default {
  name: "Tools02BussinessAccountsAccountList",
  components: {
    UiBonusAlert,
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["rt", "tool", "apiErrorMessage", "userData"]),
    ...mapGetters("tools02", ["bussinessAccountList"]),
  },
  watch: {},
  created() {
    if (this.$route.query.status === "200") {
      this.$store.dispatch("setUserData");
    } else {
      //no action.
    }
  },
  methods: {
    authorize(bussinessAccountId) {
      // 
      this.$axios
        .get(`${this.rt}/l/api/tools02/media/yahoo/create-token-for-auth?bussiness_account_id=${bussinessAccountId}`)
        .then((response) => {
          console.log(response);
          if (response.data.status === 200) {
            // URL
            let url = `https://biz-oauth.yahoo.co.jp/oauth/v1/authorize`;

            // query
            let query = "";
            query += `?response_type=code`;
            query += `&client_id=${response.data.clientId}`;
            let rootUrl = this.rt;
            if (this.rt === "http://adtasukaru.localhost") {
              rootUrl = "https://adtasukaru.com";
            } else {
              // no action.
            }
            let redirectUri = `${rootUrl}/api/tools02/yahoo-cv/get-tokens.php`;
            // if (bussinessAccountId === '3') {
            //   redirectUri = `${rootUrl}/l/api/tools02/yahoo/get-tokens`;
            // } else {
            //   // no action.
            // }
            query += `&redirect_uri=${redirectUri}`;
            query += `&scope=yahooads`;
            query += `&state=${response.data.state}`;

            //jump
            location.href = url + query;
            return;
          } else if (response.data.status === 401) {
            alert(response.data.message);
            this.$router.push("/login");
            return;
          } else {
            alert(this.apiErrorMessage);
            return;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    deleteBussinessAccount(bussinessAccountId, bussinessId) {
      if (
        confirm(
          `ビジネスID「${bussinessId}」のアカウント情報を削除します。よろしいですか？`
        )
      ) {
        // 
        let params = new URLSearchParams();
        params.append("bussiness_account_id", bussinessAccountId);
        this.$axios
          .post(`${this.rt}/l/api/tools02/media/yahoo/delete-bussiness-account`, params)
          .then((response) => {
            console.log(response);

            // 
            if (response.data.status === 200) {
              this.$store.dispatch("tools02/setBussinessAccountList");
            } else if (response.data.status === 409) {
              alert(response.data.message);
            } else if (response.data.status === 401) {
              alert(response.data.message);
              this.$router.push("/login");
            } else {
              alert(this.apiErrorMessage);
            }

            // 
            return;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        console.log("キャンセルしました。");
        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.new-add {
  margin-top: 20px;
}

.cover {
  overflow: auto;

  .typeA {
    width: 1100px;
  }
}
</style>
